import React, { useEffect, useRef } from 'react'
import './whitepaperoverview.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Whitepaperoverview = () => {
    const textRef = useRef(null);
    const paraRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: textRef.current,
                start: "top 80%",
                toggleActions: "play none none none",
            },
        });

        gsap.set(textRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(textRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
        });
    }, []);

    useEffect(() => {
        gsap.fromTo(
            paraRef.current,
            { opacity: 0, y: 50 },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: paraRef.current,
                    start: "top 90%",
                    toggleActions: "play none none none",
                },
            }
        );
    }, []);

   
    return (
        <>
            <section className='overviewwhitepaperprnt'>
                <div className="postionoverviewimg">
                    <img className='img-fluid' src="\assets\Whitepaper\postionmiddlestory.png" alt="" />
                </div>
                <div className="custom-container">
                    <div className="storyprnt">
                        <div className="rightimgprnt">
                            <img className='img-fluid imgwhitepaperoverview' src="\assets\Whitepaper\storyleftimg.png" alt="" />
                        </div>

                        <div className="aboutusmission">
                           
                            <div className="aboutusmissioncnt">
                                <h1 ref={textRef}>Overview of the Whitepaper</h1>
                                <p ref={paraRef}>TOMI’s whitepaper outlines our mission to democratize the internet by building a secure, decentralized ecosystem. Learn about our roadmap, technologies, and the vision that drives us to create a privacy-focused alternative to the current Web 2.0 model.</p>                               
                                 </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Whitepaperoverview